// extracted by mini-css-extract-plugin
module.exports = {"DiscountTooltipContent":"DiscountTooltipContent___nw3Ac"};